import api from './api';

const collectionChargeService = {
  listRules: async (params = {}) => {
    const response = await api.get('/collection-charges/rules', { params });
    return response.data;
  },

  getRule: async (id) => {
    const response = await api.get(`/collection-charges/rules/${id}`);
    return response.data;
  },

  createRule: async (payload) => {
    const response = await api.post('/collection-charges/rules', payload);
    return response.data;
  },

  updateRule: async (id, payload) => {
    const response = await api.put(`/collection-charges/rules/${id}`, payload);
    return response.data;
  },

  deactivateRule: async (id, rowVersion) => {
    const response = await api.post(`/collection-charges/rules/${id}/deactivate`, { rowVersion });
    return response.data;
  },

  activateRule: async (id, rowVersion) => {
    const response = await api.post(`/collection-charges/rules/${id}/activate`, { rowVersion });
    return response.data;
  },

  listAudit: async (params = {}) => {
    const response = await api.get('/collection-charges/audit', { params });
    return response.data;
  },

  // Draft rule + synthetic values; calculated in memory on the server, nothing is saved.
  previewRule: async (payload) => {
    const response = await api.post('/collection-charges/preview/rule', payload);
    return response.data;
  },

  // What a bill would be charged under the centre's current rule. Read-only.
  previewBilling: async (payload) => {
    const response = await api.post('/collection-charges/preview/billing', payload);
    return response.data;
  },
};

export default collectionChargeService;
